/* eslint-disable */
const FolderOpen = (props) => {
  return `<svg id='folder-open' width="${props.width || '172px'}" height="${
    props.height || '130px'
  }" viewBox="0 0 172 130" xmlns="http://www.w3.org/2000/svg" style="min-width:${
    props.width
  }"><g fill="none" fill-rule="evenodd"><path d="M15 0h41l18 17h65c8.284 0 15 6.716 15 15v83c0 8.284-6.716 15-15 15H15c-8.284 0-15-6.716-15-15V15C0 6.716 6.716 0 15 0z" fill="#FFAF00"/><path d="M42.968 41H156.26c8.285 0 15 6.716 15 15a15 15 0 0 1-.208 2.493l-9.944 59A15 15 0 0 1 146.317 130H17l11.126-76.168A15 15 0 0 1 42.968 41z" fill="#FFD233"/></g></svg>`;
};

export default FolderOpen;
/* eslint-enable */
